import { makeSearchedIssues } from 'ducks/integrations/jiraShared'

export default makeSearchedIssues('integrations/jira_server')
